export type SecondaryDataSpec = {
  buttonLabel: string;
};

/** Tombol modal secondary data. HTML templatenya dimuat dari backend. */
export function secondaryDataSpec(lhuGroupedName?: string | null): SecondaryDataSpec | null {
  const group = String(lhuGroupedName ?? '').trim();
  if (group === 'emisi_isokinetik') {
    return { buttonLabel: 'Input SECONDARY DATA OF EMISSION AIR QUALITY' };
  }
  if (group === 'plankton') return { buttonLabel: 'Input SECONDARY DATA OF PLANKTON' };
  if (group === 'bentos') return { buttonLabel: 'Input SECONDARY DATA OF BENTOS' };
  return null;
}

export function isBiologySecondaryGroup(lhuGroupedName?: string | null): boolean {
  const group = String(lhuGroupedName ?? '').trim();
  return group === 'plankton' || group === 'bentos';
}
